import { useSnackbar } from "notistack";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  getUserMFASetting,
  setUserMFASetting,
  generate2FASecret,
  verify2FASecret,
  confirmMFASignin,
} from "../utils/user-auth-provider";

export const use2FASetting = () => {
  return useQuery("twoFASetting", () => getUserMFASetting(), {
    retry: 2,
    cacheTime: 0,
    onError: (err) => {
      console.error(err);
    },
  });
};

export const useToggle2FASetting = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation(
    (toggle2FASetting: { enabled: boolean }) => setUserMFASetting(toggle2FASetting.enabled),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries("twoFASetting");
        enqueueSnackbar("Setup 2FA successfully", {
          variant: "success",
        });
      },
      onError: (err) => {
        console.error(err);
        enqueueSnackbar("Failed to toggle 2FA setting", {
          variant: "error",
          autoHideDuration: 3000,
        });
      },
    }
  );
};

export const useGenerate2FASecret = () => {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(() => generate2FASecret(), {
    onError: (err) => {
      console.error(err);
      enqueueSnackbar("Failed to generate 2FA QRCode", {
        variant: "error",
        autoHideDuration: 3000,
      });
    },
  });
};

export const useVerify2FASecret = () => {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(
    (verify2FASecretData: { token: string }) => verify2FASecret(verify2FASecretData.token),
    {
      onError: (err) => {
        console.error(err);
        enqueueSnackbar("Failed to verify 2FA QRCode", {
          variant: "error",
          autoHideDuration: 3000,
        });
      },
    }
  );
};

export const useConfirmMFASignIn = () => {
  return useMutation((confirmSignInData: { token: string }) =>
    confirmMFASignin(confirmSignInData.token)
  );
};
